import { render, staticRenderFns } from "./LayoutBuyingGuide.vue?vue&type=template&id=5adb181c&"
import script from "./LayoutBuyingGuide.vue?vue&type=script&lang=js&"
export * from "./LayoutBuyingGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports